import React from 'react'
import StyledAccordion, { useAccordionStyles } from '../../../shared/styles/accordion.styles'
import { AccordionDetails, AccordionSummary, Divider, Stack, Typography } from '@mui/material'
import { J1DownarrowD } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { WallboxType } from '../../models/wallbox-model'
import { TariffModel } from '../../../tariffs/models/tariffs-model'
import { getCurrencyValue } from '../../../shared/utils/currency-value'
import { format } from '@e3dc-react/shell/Libs/date'

interface TariffAccordionItemProps {
  tariff?: TariffModel
  wallboxType: WallboxType
}

export const TariffAccordionItem: React.FC<TariffAccordionItemProps> = ({ tariff, wallboxType }) => {
  const { t } = useCustomTranslation()
  const { classes } = useAccordionStyles()

  return (
    <StyledAccordion elevation={0} disabled={!tariff} sx={{ borderRadius: 0 }}>
      <AccordionSummary expandIcon={<J1DownarrowD />} className={classes.accordionSummary}>
        <Typography>{t('emobility.wallbox.editTariffs.accordionTitle')}</Typography>
      </AccordionSummary>

      {tariff && (
        <AccordionDetails>
          <Stack className={classes.accordionRow}>
            <Typography>{t('emobility.wallbox.pricePerKwh')}</Typography>
            <Typography fontWeight="500">{getCurrencyValue(tariff.staticPrices.gridPrice ?? 0, tariff.currencyCode)}</Typography>
          </Stack>
          <Divider className={classes.divider} />

          <Stack className={classes.accordionRow}>
            <Typography>{t('emobility.wallbox.solar-price')}</Typography>
            <Typography fontWeight="500">{getCurrencyValue(tariff.staticPrices.solarPrice ?? 0, tariff.currencyCode)}</Typography>
          </Stack>
          <Divider className={classes.divider} />

          {wallboxType === WallboxType.Bidi && (
            <>
              <Stack className={classes.accordionRow}>
                <Typography>{t('emobility.wallbox.dischargePricePerKwh')}</Typography>
                <Typography fontWeight="500">{getCurrencyValue(tariff.dischargePrice ?? 0, tariff.currencyCode)}</Typography>
              </Stack>
              <Divider className={classes.divider} />
            </>
          )}

          <Stack className={classes.accordionRow}>
            <Typography>{t('emobility.wallbox.editTariffs.startDate')}</Typography>
            <Typography fontWeight="500">{tariff.startTime ? format(new Date(tariff.startTime), t('common.format.date-fns-date')) : '-'}</Typography>
          </Stack>
          <Divider className={classes.divider} />

          <Stack className={classes.accordionRow}>
            <Typography>{t('emobility.wallbox.editTariffs.endDate')}</Typography>
            <Typography fontWeight="500">{tariff.endTime ? format(new Date(tariff.endTime), t('common.format.date-fns-date')) : '-'}</Typography>
          </Stack>
        </AccordionDetails>
      )}
    </StyledAccordion>
  )
}
